export default function shouldShow() {
    const key = 'login-frontend-eid-popup-shown';
    const oneweek = 7 * 60 * 60 * 24 * 1000;
    const now = +new Date();

    try {
        const urlParams = new URLSearchParams(window.location.search);
        const forcePopup = urlParams.get('show-eid-popup') === 'true';
        if (forcePopup) {
            return true;
        }

        const lastViewed = parseInt(localStorage.getItem(key) || '0', 10);
        if (now - lastViewed > oneweek) {
            localStorage.setItem(key, now.toString(10));
            console.log('Show popup stored in localStorage');
            return true;
        }
    } catch (e: unknown) {
        // Ignore errors from browsers that does not support localStorage.
        if (
            !(
                e instanceof Error &&
                e.message === 'The quota has been exceeded.'
            )
        ) {
            console.error(e);
        }
    }
    return false;
}
